import { t } from "@lingui/macro"
import { observer } from "mobx-react"

import { AccessDetailStore } from "./store"

import { FormFieldSet } from "src/components/FormFieldSet"
import { SegmentPickerField } from "src/components/SegmentPickerField"
import { useStore } from "src/store/lib/useStore"

export const PublishingSettingsSection = observer(() => {
    const store = useStore(AccessDetailStore)

    return (
        <FormFieldSet
            header={t`access-detail-modal.publishing-settings-section.field-set-header`}
        >
            <SegmentPickerField
                value={store.formFields.get("segmentIds")}
                accessGroupId={store.formFields.get("accessGroupId")}
                onChange={(segmentIds) =>
                    store.formFields.set("segmentIds", segmentIds)
                }
            />
        </FormFieldSet>
    )
})
